export const DOES_NOT_SUPPORT_CHOOSING_SOUND_OUTPUT: string = 'Your browser does not support choosing sound output.';
export const AUDIO_OUTPUT_EMPTY: string = 'Please connect an audio output device';
